/* eslint-disable react/prop-types */
import React from 'react';
import {
  VideoJSPlayerContextProvider,
  lightTheme
  // AnalyticsContextProvider
} from '@entertainment-ai/mansueto';
import VideoPlayer from './VideoPlayer';
import Playlist from './Playlist';
import { ThemeProvider } from 'styled-components';
import { SSRProvider } from '@react-aria/ssr';
import { connect } from 'react-redux';

const customizedTheme = {
  ...lightTheme,
  videoBorderRadius: '0',
  transcriptionLanguageFontSize: '0',
  transcriptionTimeBg: 'transparent',
  transcriptionTimeColor: '#000',
  transcriptionTimeFontSize: '13px',
  transcriptionTimeHeight: 'fit-content',
  transcriptionMaxWidth: 'initial',
  transcriptionCaptionsFontSize: '15px'
};

const Index = ({ video }) => (
  <main className="eventsWatch">
    <SSRProvider>
      {/* <AnalyticsContextProvider
        title="Fast Company"
        clientMeasurementId="G-VZLE7091ZM"
        clientTrackingId="UA-4300461-33"
      > */}
      <ThemeProvider theme={customizedTheme}>
        <VideoJSPlayerContextProvider>
          <VideoPlayer video={video} />
        </VideoJSPlayerContextProvider>
      </ThemeProvider>
      {/* </AnalyticsContextProvider> */}
    </SSRProvider>
    {
      <Playlist
        currentVideoId={video?.id}
        tags={video?.tags?.map(tag => tag.value) || []}
        limit={12}
      />
    }
  </main>
);

const mapStateToProps = state => ({
  video: state.eventsPage.data.video
});

export default connect(mapStateToProps)(Index);
